import React, { useCallback, useState, useEffect } from 'react'
import { Field } from 'redux-form'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

function TextAreaBoxHook (props) {
  const { rows = 3, type, ...rest } = props
  const { input: { onBlur, onChange, value } } = props

  const [ currentValue, setCurrentValue ] = useState()

  useEffect(() => {
    setCurrentValue(value)
  }, [value])

  const fireOnChange = useCallback(_.debounce((v) => {
    if (_.isFunction(onChange)) {
      onChange(v)
    }
  }, 1000), [])

  const handleOnBlur = useCallback((e) => {
    if (_.isFunction(onBlur)) {
      let newValue = _.trim(e.target.value)
      onBlur(newValue)
    }
  }, [])

  function handleOnChange (e) {
    setCurrentValue(e.target.value)
    fireOnChange(e.target.value)
  }

  return <FieldLayoutBox {...rest}>
    {({ testId, showError, name, placeHolder, loading, readonly }) => {
      if (readonly) {
        return <textarea data-tid={testId} className={clsx(showError && 'is-invalid-input')} rows={rows || 3} readOnly name={`view${name}`} id={`view${name}`} placeholder={placeHolder} value={currentValue} />
      } else {
        return <textarea data-tid={testId} className={clsx(showError && 'is-invalid-input')} rows={rows || 3} invalid={showError} name={`textarea${name}`} id={`textarea${name}`} onBlur={handleOnBlur} placeholder={placeHolder} onChange={handleOnChange} value={currentValue} />
      }
    }}
  </FieldLayoutBox>
}

export const TextAreaBox = ({ parse, format, fieldType, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={TextAreaBoxHook} /> } // eslint-disable-line
export default TextAreaBox
